<template>
  <div>

    <div class="layout-fw home-wrapper">
      <div class="layout-fix layout-tl layout-fw home-nav layout-cc">
        <div class="home-container home-nav-h">
          <div class="nav-top-row layout-fw">
            <h1 class="lok-brand">Lok Lok Academy</h1>

            <!--
            <h2 class="lok-access">signup / login playground</h2>
            -->
          </div>
          <div class="nav-bottom-row layout-fw">
            <router-link to="/">
              <span class="nav-breadcrums is-home">Home</span>
            </router-link>
            <span class="nav-breadcrums">modern-javascript-basics</span>

            <select class="nav-breadcrums-select" v-model="currentEgIdx">
              <option v-for="(example, exampleID) in examples" :value="exampleID">{{ example.title }}</option>
            </select>
            <form @submit="saveTitle(updatedTitle)" v-if="currentExample">
              <input type="text" :value="currentExample.title" @input="(evt) => { this.updatedTitle = evt.target.value; }">
              <input type="submit" value="update title">
            </form>

            <button @click="removeExample(currentExample)">X</button>
            <form @submit="addExample">
              Add new: <input v-model="newTitle"></input>
            </form>

          </div>
        </div>
      </div>
      <div class="layout-fw layout-hc">
        <div class="home-container layout-fh">

          <div class="home-padding">

            <!--
            <h2>examples</h2>
            <pre>{{ JSON.stringify(examples, null, '  ') }}</pre>
            -->

            <Coder :example="currentExample" v-if="currentExample" />

            <!--
            -->

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import { mapActions } from 'vuex'
import Coder from './Coder'
import { db } from '@/firebase'

var dbExamples = db.ref('examples')

export default {
  name: 'CodeSample',
  components: {
    Coder
  },
  firebase: {
    examplesSource: {
      source: dbExamples,
      readyCallback () {
        this.ready = true
      }
    }
  },
  computed: {
    examples () {
      return this.examplesSource.slice().sort((a, b) => {
        // console.log(a)
        if (a.title && b.title) {
          if (a.title < b.title) return -1
          if (a.title > b.title) return 1
          return 0
        } else {
          return 0
        }
      }) || []
    },
    currentExample () {
      return this.examples[this.currentEgIdx]
    }
  },
  data () {
    return {
      ready: false,
      newTitle: '',
      updatedTitle: '',
      currentEgIdx: 0,
      examplesSource: []
    }
  },
  methods: {
    selectExample (index) {
      this.currentEgIdx = index
    },
    removeExample (example) {
      window.confirm('Remove Example?') &&
      dbExamples.child(example['.key']).remove()
      this.currentEgIdx = 0
    },
    saveTitle (newTitle) {
      dbExamples.child(this.currentExample['.key']).child('title').set(newTitle)
    },
    addExample (evt) {
      evt.preventDefault()

      if (this.newTitle.trim()) {
        dbExamples.push({
          title: this.newTitle,
          codes: [
            {
              script: '',
              explanation: ''
            }
          ]
        })
      }

      this.newTitle = ''
      this.currentEgIdx = this.examples.length - 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './layout.scss';
//=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
//
//=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
$nav-height: 140px;
.home-nav-h{
  height: $nav-height;
}
.home-nav{
  font-family: 'Exo 2';

  height: $nav-height;
  // background-color: red;
}
.home-wrapper{
  // background-color: yellow;
  padding-top: $nav-height;
}

.home-container{
  background-color: white;
  width: 100vw;
  max-width: 1440px;
}

.nav-top-row {
  height: 80px;
  // background-color: yellow;
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.lok-brand{
  padding: 0px 25px;
}
.lok-access{
  padding: 0px 25px;
}
.nav-bottom-row{
  padding: 0px 25px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.nav-breadcrums{
}
.nav-breadcrums-select{
  font-size: 20px;
  // -webkit-appearance: none;
  //  -moz-appearance: none;
  //  appearance: none;
}

.nav-breadcrums{
  position: relative;
  padding: 0px 15px 0px 15px;
}

.is-home.nav-breadcrums{
  padding-left: 0px;
}

.nav-breadcrums:before{
  content: "/";
  position: absolute;
  top: 0px;
  left: 0px;
}
.is-home.nav-breadcrums:before{
  content: '';
}

.home-padding{
  padding: 0px 25px;
}



</style>



// WEBPACK FOOTER //
// CodeSample.vue?16700d94